<template>
  <el-select :value="value" @change="change" filterable remote :remote-method="search">
    <el-option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: Number
  },
  data () {
    return {
      salesList: []
    }
  },
  watch: {
    'value' (val) {
      if (val > 0 && this.salesList.length === 0) {
        this.$http.get('/dbapi/sales_list?id=' + val).then(data => {
          this.salesList = data.list
        })
      }
    }
  },
  mounted () {
    this.$http.get('/dbapi/sales_list').then(data => {
      this.salesList = data.list
    })
  },
  methods: {
    change (v) {
      this.$emit('input', v)
      let companys = this.companyList.filter(r => r.id === v)
      if (companys.length > 0) {
        this.$emit('change', companys[0])
      }
    },
    search (query) {
      this.$http.get('/dbapi/sales_list?query=' + query).then(data => {
        this.salesList = data.list
      })
    }
  }
}
</script>